import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';
import { useInstallationData } from './useInstallationData';

const JambType = ({ value, onChange, id = 'JambType', label = 'Jamb Type', disabled = false, showPics = false, hideOptions = [], appliesTo = 'windows' }) => {
    const [showModal, setShowModal] = useState(false);
    const { getJambTypes, loading, error } = useInstallationData(appliesTo);

    const allOptions = getJambTypes();
    const options = allOptions.filter(option => !hideOptions.includes(option.value));

    const defaultValue = value?.value || '';
    const initialValue = (defaultValue && options.find(o => o.value === defaultValue)) ? defaultValue : (options[0]?.value || '');
    const [selectedValue, setSelectedValue] = useState(initialValue);

    // Update selected value when value prop changes or options change
    useEffect(() => {
        const newValue = (value?.value && options.find(o => o.value === value.value)) ? value.value : (options[0]?.value || '');
        setSelectedValue(newValue);
        if (newValue !== value?.value && options.length > 0) {
            const option = options.find(o => o.value === newValue);
            onChange({ value: newValue, label: option?.label || newValue });
        }
    }, [value?.value, hideOptions, loading]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedValue(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    if (error) {
        console.error('Error loading jamb types:', error);
    }

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>
            <select
                disabled={disabled || loading}
                id={id}
                value={selectedValue}
                onChange={handleChange}
            >
                {loading ? (
                    <option value="">Loading...</option>
                ) : (
                    options.map(option => (
                        <option key={option.id} value={option.value}>
                            {selectedValue === option.value ? `${option.label} ✔` : option.label}
                        </option>
                    ))
                )}
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/JambType"
                imageName={selectedValue}
                width={200}
                height={250}
            />
        </div>
    );
};

export default JambType;
